// Klein hulpbestand om een korte notificatie-bliep af te spelen zonder een
// asset-bestand nodig te hebben. We gebruiken de Web Audio API zodat het geluid
// puur in de browser wordt gegenereerd. De AudioContext wordt pas aangemaakt op
// het moment dat we echt willen afspelen, omdat browsers 'm blokkeren tot er
// gebruikers-interactie is geweest op de pagina.

const STORAGE_KEY = 'tickets:new-ticket-sound-enabled';

export function isTicketSoundEnabled() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    // Default AAN: gebruikers willen meestal meteen horen dat er iets binnenkomt.
    if (raw == null) return true;
    return raw === '1' || raw === 'true';
  } catch {
    return true;
  }
}

export function setTicketSoundEnabled(enabled) {
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0');
  } catch {
    /* localStorage niet beschikbaar; negeren */
  }
}

let sharedCtx = null;

function getCtx() {
  if (sharedCtx) return sharedCtx;
  const Ctor = window.AudioContext || window.webkitAudioContext;
  if (!Ctor) return null;
  try {
    sharedCtx = new Ctor();
  } catch {
    sharedCtx = null;
  }
  return sharedCtx;
}

// Speelt een korte, vriendelijke twee-tonen-bliep af (ongeveer 300ms totaal).
// Honoreert de "geluid uit"-instelling in localStorage.
export function playNewTicketSound({ force = false } = {}) {
  if (!force && !isTicketSoundEnabled()) return;
  const ctx = getCtx();
  if (!ctx) return;
  try {
    if (ctx.state === 'suspended' && typeof ctx.resume === 'function') {
      ctx.resume().catch(() => {});
    }
    const now = ctx.currentTime;

    const playTone = (freq, startOffset, durationSec) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, now + startOffset);

      const start = now + startOffset;
      const end = start + durationSec;
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.18, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, end);

      osc.connect(gain).connect(ctx.destination);
      osc.start(start);
      osc.stop(end + 0.02);
    };

    playTone(880, 0, 0.12);
    playTone(1320, 0.12, 0.18);
  } catch {
    /* audio-fout negeren — niet kritisch */
  }
}
